import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e: FormEvent) => {
    e.preventDefault();
    // Newsletter subscription logic here
    console.log('Newsletter subscription:', email);
    setEmail('');
  };

  return (
    <footer className="bg-gray-950 text-white py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Top Row */}
        <div className="flex flex-col sm:flex-row items-start justify-between mb-12 sm:mb-16 gap-4">
          <div className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/d9bb5601c98f22586a2b11870925187d/b857441a8282eff6e67d45b8b6cd5de0.jpeg"
              alt="Horizon Pathways Logo"
              className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
            />
            <span className="text-xl sm:text-2xl font-semibold">Horizon Pathways</span>
          </div>
          <p className="text-gray-400 text-xs sm:text-sm">
            Your trusted partner in agricultural exports
          </p>
        </div>

        {/* Middle Navigation Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10 md:gap-12 mb-12 sm:mb-16">
          {/* Products Column */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Products</h3>
            <ul className="space-y-2 sm:space-y-3">
              {['Pulses', 'Spices', 'Rice', 'Maize', 'Coffee', 'Tea'].map((item) => (
                <li key={item}>
                  <Link
                    to="/products"
                    className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors cursor-pointer"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Services</h3>
            <ul className="space-y-2 sm:space-y-3">
              {[
                'Export Documentation',
                'Quality Assurance',
                'Logistics Support',
                'Custom Clearance',
              ].map((item) => (
                <li key={item}>
                  <Link
                    to="/services"
                    className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors cursor-pointer"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Company</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors cursor-pointer"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/about#certifications"
                  className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors cursor-pointer"
                >
                  Certifications
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors cursor-pointer"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div className="text-left md:text-right">
            <p className="text-white font-serif text-sm sm:text-base mb-2">
              &copy; Horizon Pathways 2025
            </p>
            <p className="text-gray-400 text-xs sm:text-sm">All rights reserved</p>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 items-center pt-8 sm:pt-12 border-t border-gray-800">
          {/* Left Image */}
          <div className="rounded-xl sm:rounded-2xl overflow-hidden h-40 sm:h-48">
            <img
              src="https://public.readdy.ai/ai/img_res/fcd77a77c844444ed8e08bceaa598a75.jpg"
              alt="Our Facility"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Center Text */}
          <div className="text-center">
            <h3 className="text-xl sm:text-2xl md:text-3xl font-serif text-white leading-relaxed">
              Quality Assured
              <br />
              Globally Delivered
              <br />
              Sustainably Sourced
            </h3>
          </div>

          {/* Right Newsletter */}
          <div>
            <p className="text-gray-400 text-xs sm:text-sm mb-3 sm:mb-4">
              Subscribe for export insights and product updates
            </p>
            <form onSubmit={handleNewsletterSubmit} className="flex gap-2">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="flex-1 px-3 sm:px-4 py-2.5 sm:py-3 bg-transparent border-2 border-gray-700 rounded-lg text-white placeholder-gray-500 focus:border-blue-600 focus:outline-none transition-colors text-xs sm:text-sm"
              />
              <button
                type="submit"
                className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-600 rounded-lg flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer flex-shrink-0"
              >
                <i className="ri-arrow-right-line text-white text-lg sm:text-xl"></i>
              </button>
            </form>
          </div>
        </div>

        {/* Quick Link */}
        <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-gray-800 text-center">
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 text-xs hover:text-gray-400 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
